module.exports = __webpack_public_path__ + "static/media/sliit2.d987bc65.png";